import { Board } from 'entities/task/model/types/tasksInformationSchema';

export const filterBoard = (board: Board, filteredTasksId: string[]): Board => {
    return {
        in_progress: board.in_progress.filter((id) => filteredTasksId.includes(`${id}`)),
        no_term: board?.no_term?.filter((id) => filteredTasksId.includes(`${id}`)),
        outdated: board.outdated.filter((id) => filteredTasksId.includes(`${id}`)),
        today: board.today.filter((id) => filteredTasksId.includes(`${id}`)),
        seven_days: board.seven_days.filter((id) => filteredTasksId.includes(`${id}`)),
    };
};
